import Swal from "sweetalert2";
import validator from 'validator';


export const valFormValuesCustom = (props) => {
    const { formValues } = props;
    console.log(formValues);

    const {
        // Default params for all the cases
        partApellidoPaterno,
        partNombres,
        partCorreo,

        tipoRegistro,
        trabajos,

        claveProyecto,
        
        // rnav (emaeda@)
        partGenero,
        partNacionalidad,
        partTelefono,

        profInstitucion,
        profDireccion,
        profPais,
        profEstado,
        profGrado,
        profOcupacion,

        totalTrabajos,
    } = formValues;

    
    /* 
        For every project, just add a -case- and it's validations
    */

    switch (claveProyecto) {
        // rnav (emaeda@)
        case '20493':
            // Required data in works
            if (tipoRegistro === 'Ponente') {

                if ([totalTrabajos].includes("")) {
                    Swal.fire("Datos incompletos [Tipo de participación]", "Los campos marcados con [ * ] son obligatorios.", "error");
                    return false;
                }

                let isWorkInvalid = null;
                trabajos.forEach( (trab, index) => {

                    // Datos de cada trabajo
                    if ([
                            trab.trabModalidad,
                            trab.trabTitulo,
                            trab.trabOrientacion,
                            trab.trabPalabrasClave,
                        ].includes("")) {
                            isWorkInvalid = {id: index, reason: 'Datos de trabajo incompletos.'};
                    }
                    console.log(trab.trabResumenFile.file);
                    if (!trab.trabResumenFile.file) {
                        isWorkInvalid = {id: index, reason: 'Selecciona un archivo.'};
                    } else {
                        const type = trab.trabResumenFile.file.type;
                        if (type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document" && type !== "application/msword") {
                            isWorkInvalid = {id: index, reason: 'Tipo de archivo incorrecto.'};
                        }
                    }

                    // Autores de cada trabajo
                    const { trabAutores } = trab;
                    console.log({ trabAutores });
                    trabAutores.forEach( (autor) => {
                        console.log({autor});
                        if ([
                                autor.autorApellidos,
                                autor.autorEmail,
                                autor.autorNombres,
                                autor.autorProcedencia,
                            ].includes("")) {
                                isWorkInvalid = {id: index, reason: 'Datos de autor incompletos.'};
                            }
                    })

                });

                console.log(isWorkInvalid);
                if (isWorkInvalid !== null) {
                    Swal.fire(`${ isWorkInvalid.reason }`, `En [ Tipo de participación ] los campos marcados con * del Trabajo ${isWorkInvalid.id + 1} son obligatorios.`, "error");
                    return false;
                }
            }

            // Required fields
            if ([   partGenero,
                    partNacionalidad,
                    partTelefono, 
                    profInstitucion,
                    profDireccion,
                    profPais,
                    profEstado,
                    profGrado,
                    profOcupacion,
                ].includes("")
            ) { 
                Swal.fire("Datos incompletos", "Campos marcados con [ * ] en cualquier sección son obligatorios.", "error");
                return false;
            }


            break;
    
        default:
            break;
    }

    // Required for all cases
    if (
        [ partApellidoPaterno, partNombres, partCorreo, tipoRegistro ].includes("")
    ) {
        Swal.fire("Datos incompletos", "Los campos marcados con [ * ] son obligatorios.", "error");
        return false;
    }
    // El correo es invalido
    if ( !validator.isEmail(partCorreo) ) {
        Swal.fire("Correo electrónico incorrecto.", "El formato del correo electrónico no es valido.", "error");
        return false;
    }

    // Everything is Ok
    return true;
};
